import { createProjectBuilder } from "@spawn/nrg-games-core";
import { GameDiProject } from "./diProject";
import { Game } from "./game";

/**
 * This is the main entry point of the game.
 * It's responsible for creating the game and all the dependencies.
 */
export const projectBuilder = createProjectBuilder(GameDiProject);

export const game = Game;
